var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticClass:"card-title"},[_vm._v("Team Map")]),_c('img',{staticClass:"img-fluid py-3",attrs:{"src":_vm.image,"alt":"story-img"}})])}
var staticRenderFns = []

export { render, staticRenderFns }